const isObject = variable =>
  Object.prototype.toString.call(variable) === '[object Object]'

export default isObject
